<div class="users-container">
  <app-main-kpis />
  <app-tabs [defaultTab]="defaultTab()" (onChangeTab)="onTabChange($event)">
    <app-sales-performance-tab />
    <app-products-performance-tab />
    <app-classes-distribution-tab />
    <app-market-samples-tab />
    <app-product-samples-tab />
    <app-accumulative-list-tab />
  </app-tabs>
</div>
